var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9956 11.7503C11.8586 10.5884 11.6781 9.78864 11.5506 9.32179C11.4518 8.94803 11.2178 8.61885 10.8916 8.39274C9.54203 7.45904 8.35281 7.01378 7.80703 6.84106C7.27182 7.21064 6.65404 7.4284 6.00027 7.4284C5.34649 7.4284 4.72872 7.21064 4.1935 6.84106C3.64749 7.01378 2.45826 7.45881 1.10871 8.39274C0.782298 8.61885 0.548533 8.94826 0.45013 9.31993C0.322447 9.78887 0.141963 10.5888 0.00491927 11.7496C-0.0349217 12.0783 0.170763 12.3933 0.494051 12.4992C1.20231 12.7274 2.73355 12.9999 6.00003 12.9999C9.26651 12.9999 10.7977 12.7274 11.5072 12.4987C11.8291 12.3933 12.0347 12.0781 11.9951 11.75L11.9956 11.7503Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12052 3.26376C9.12052 1.4031 7.77913 0 6.00045 0C4.22176 0 2.88037 1.4031 2.88037 3.26376C2.88037 5.23515 4.33841 6.96441 6.00045 6.96441C7.66249 6.96441 9.12052 5.23515 9.12052 3.26376Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleUser);
export default __webpack_public_path__ + "static/media/singleUser.bc4112119c02c8ee4abadf8c0804079d.svg";
export { ForwardRef as ReactComponent };